// blakfy-cookie/src/i18n/translations/de.js — German translations

export default {
  title: "Cookie-Einstellungen",
  intro:
    "Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern. Weitere Informationen in unserer Cookie-Richtlinie.",
  policyLink: "Cookie-Richtlinie",
  acceptAll: "Alle akzeptieren",
  rejectAll: "Alle ablehnen",
  preferences: "Einstellungen",
  save: "Auswahl speichern",
  close: "Schließen",
  cat: {
    essential: {
      title: "Notwendige Cookies",
      desc: "Für die Grundfunktionen der Website erforderlich. Können nicht deaktiviert werden.",
      always: "Immer aktiv",
    },
    analytics: {
      title: "Analyse-Cookies",
      desc: "Werden verwendet, um anonyme Besuchsstatistiken zu sammeln.",
    },
    marketing: {
      title: "Marketing-Cookies",
      desc: "Werden für personalisierte Werbung und Retargeting verwendet.",
    },
    functional: {
      title: "Funktionale Cookies",
      desc: "Werden verwendet, um Einstellungen wie Sprache und Theme zu speichern.",
    },
  },
  placeholder: {
    title: "Inhalt blockiert",
    desc: "Sie müssen {category}-Cookies erlauben, um diesen Inhalt anzuzeigen.",
    cta: "Erlauben",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
